<template>
  <transition
    v-if="loadingData"
    key="loading"
    name="custom-bounce">
    <v-layout row justify-center>
      <v-progress-circular v-if="loadingData"
        :width="3"
        color="primary"
        indeterminate
      />
    </v-layout>
  </transition>
  <v-layout
    v-else-if="showPlaceholder"
    key="no-answer-or-empty"
    row
    justify-center>
    <h4 class="text-xs-center font-weight-light">{{ messagePlaceholder }}</h4>
  </v-layout>
  <v-layout v-else key="trays-to-show" column fill-height>
    <v-layout row pa-2>
      <v-select
        v-model="selectedMeal"
        :items="mealOptionsItems"
        item-text="text"
        item-value="value"
        item-disabled="disabled"
        label="Refeição"
        solo
        hide-details
      />
    </v-layout>

    <v-layout row wrap pa-2>
      <v-flex xs3>
        <v-layout align-center justify-center column fill-height>
          <v-btn icon depressed :disabled="previousButton" @click="navigateDays('previous')">
            <v-icon>arrow_back_ios</v-icon>
          </v-btn>
        </v-layout>
      </v-flex>

      <v-flex xs6>
        <v-layout align-center justify-center column fill-height>
        <h3 class="title">{{ dateTrays }}</h3>
        </v-layout>
      </v-flex>

      <v-flex xs3>
        <v-layout align-center justify-center column fill-height>
          <v-btn icon depressed :disabled="nextButton" @click="navigateDays('next')">
            <v-icon>arrow_forward_ios</v-icon>
          </v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
    <div class="pa-2">
      <trays-flickity
        :pictures="picturesToShow"
        layoutDirection="column"
        :imageAlign="['mt-2']"
        />
    </div>
  </v-layout>
</template>

<script>
import TraysFlickity from './TraysFlickity'
import { formatTimestamp } from '@/helpers/formatTimestamp'
import mealTypes from '@/helpers/mealTypes'

/**
 * @group Meal Control
 * Controla estrutura de vizualização para mobile(até 1024px) possibilitando
 * o usuario navegar sobre cada um dos dias e visualizar as bandejas para a
 * refeição selecionada. Obs: É um subcomponente de [MealCard](/components/MealCard).
 */
export default {
  name: 'TraysMobileCard',

  components: {
    TraysFlickity
  },

  props: {
    // Controla o status de erro ao buscar informações
    errorRequest: {
      type: Boolean,
      default: false
    },
    // Controla o status de carregamento de informações
    loadingData: {
      type: Boolean,
      default: false
    },
    // Lista das bandejas dos estudantes
    studentTrays: {
      type: Array,
      // []
      default () { return [] }
    }
  },

  data: () => ({
    messageError: 'Não foi possível procurar por bandejas.',
    messageEmpty: 'Não há bandejas para o período selecionado.',
    selectedMeal: '',
    trayIndex: 0
  }),

  computed: {
    dateTrays () {
      const dateFormat = 'DD/MM/YYYY'
      return formatTimestamp((this.studentTrays[this.trayIndex] || []).date, dateFormat)
    },

    mealDate () {
      return this.studentTrays[this.trayIndex].date
    },

    mealOptionsItems () {
      return this.mealOptions()
    },

    messagePlaceholder () {
      return this.errorRequest ? this.messageError : this.messageEmpty
    },

    nextButton () {
      return this.studentTrays.length === this.trayIndex + 1
    },

    picturesToShow () {
      return this.trayPicturesToShow((this.studentTrays[this.trayIndex] || []).meals, this.selectedMeal)
    },

    previousButton () {
      return this.trayIndex === 0
    },

    showPlaceholder () {
      return this.studentTrays.length === 0 || this.errorRequest
    }
  },

  watch: {
    studentTrays (newValue) {
      if (newValue.length > 0) {
        this.trayIndex = this.studentTrays.length - 1
        this.presetMeal()
      }
    }
  },

  mounted () {
    if (this.studentTrays.length > 0) {
      this.trayIndex = this.studentTrays.length - 1
    }
    this.presetMeal()
  },

  methods: {
    // @vuese
    // Processa e formata as opções disponiveis de refeições
    mealOptions () {
      let mealItems = []
      mealTypes.forEach(type => {
        const disabled = ((this.studentTrays[this.trayIndex] || []).meals || []).find(meal => {
          return meal.meal_type === type.alias
        })
        mealItems.push({ value: type.alias, text: type.name, disabled: !disabled })
      })
      this.presetMeal()
      return mealItems
    },
    /** @vuese
     * Valida e executa a navegação entre os dias
     * @arg Passar a direção de navegação: 'next'/'previous'
     */
    navigateDays (goTo = '') {
      if (goTo === 'previous' && this.trayIndex !== 0) {
        this.trayIndex--
      } else if (goTo === 'next' && this.studentTrays.length - 1 !== this.trayIndex) {
        this.trayIndex++
      }
      this.presetMeal()
    },
    // @vuese
    // Aponta para a primeira refeição do dia
    presetMeal () {
      if (this.studentTrays.length > 0) {
        this.selectedMeal = this.studentTrays[this.trayIndex].meals[0].meal_type
      }
    },
    /**
     * @vuese
     * Usado para formatar imagens que serão passadas para TrayFlickity
     * @arg Recebe o array de refeições e a refeição desejada
     */
    trayPicturesToShow (meals = [], mealType) {
      const mealTypeToFind = meal => meal.meal_type === mealType
      const traysOfCurrentMeal = meals.find(mealTypeToFind) || {}

      return traysOfCurrentMeal.pictures || []
    }
  }
}
</script>
